/* Base */
// require('jquery');
require('lodash');
require('moment');
// require('signalR');
